import React, { useRef, useState } from "react";
import filterrSvg from "../../assets/images/funnel.svg";
import QuotationCreateMenu from "./QuotationCreateMenu";
import QuotationFilterDropdown from "./QuotationFilterDropdown";
import QuotationViewToggleIcon from "./QuotationViewToggleIcon";
const QuotationToolbar = ({
  ApplyFilter,
  ApplySearch,
  ClearFilter,
  RefreshList,
  addFilterRow,
  countryData,
  customerData,
  distributorData,
  filterRows,
  handleFilterDateChange,
  handleFilterFieldChange,
  handleFilterValueChange,
  handleKeyDown,
  hasActiveFilters,
  menuRights,
  navigateToJobInHand,
  projectData,
  removeFilterRow,
  removeSearch,
  search,
  setSearch,
  totalRecords,
  viewType,
  setViewType,
}) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const commandBarRef = useRef(null);
  const isQuoteReferenceView = viewType === "quotation";
  const nextViewLabel = isQuoteReferenceView ? "project list view" : "quote reference view";
  const viewToggleIconType = isQuoteReferenceView ? "project" : "quote";

  return (
    <div className="card quote-toolbar-card">
      <div className="card-body">
        <div className="row search-area-row">
          <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 my-auto">
            <div className="quote-title-group">
              <p>{totalRecords || 0} Results Found</p>
            </div>
          </div>
          <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-sm-12 col-xs-12 my-auto">
            <div className="quote-command-bar" ref={commandBarRef}>
              <div className="quote-search-suite">
                <div className="input-group text-align quote-search-control">
                  <input
                    id="quotation-search"
                    name="quotationSearch"
                    type="text"
                    className="form-control"
                    placeholder={isQuoteReferenceView ? "Search quote reference" : "Search project"}
                    value={search}
                    onChange={(event) => setSearch(event.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  {search && (
                    <button className="btn search-clear-btn" type="button" onClick={removeSearch} title="Clear search">
                      <i className="fas fa-times"></i>
                    </button>
                  )}
                  <button className="btn search-submit-btn" type="button" onClick={ApplySearch} title="Search">
                    <i className="fa fa-search"></i>
                  </button>
                </div>

                <div className="dropdown filter-dropdown quote-filter-control">
                  <button
                    className={`btn filter-btn ${hasActiveFilters ? "filter-active" : ""}`}
                    type="button"
                    id="filterDropdown"
                    aria-haspopup="true"
                    aria-expanded={isFilterOpen}
                    title="Advanced filters"
                    onClick={() => setIsFilterOpen((currentValue) => !currentValue)}
                  >
                    <img src={filterrSvg} alt="Filter" />
                  </button>
                  {isFilterOpen && (
                    <QuotationFilterDropdown
                      ApplyFilter={ApplyFilter}
                      ClearFilter={ClearFilter}
                      addFilterRow={addFilterRow}
                      countryData={countryData}
                      customerData={customerData}
                      distributorData={distributorData}
                      filterRows={filterRows}
                      handleFilterDateChange={handleFilterDateChange}
                      handleFilterFieldChange={handleFilterFieldChange}
                      handleFilterValueChange={handleFilterValueChange}
                      onCloseFilter={() => setIsFilterOpen(false)}
                      positioningTargetRef={commandBarRef}
                      projectData={projectData}
                      removeFilterRow={removeFilterRow}
                    />
                  )}
                </div>
              </div>

              <button
                className={`btn quote-view-toggle-btn ${isQuoteReferenceView ? "quote-view-active" : ""}`}
                type="button"
                onClick={() => setViewType?.(isQuoteReferenceView ? "project" : "quotation")}
                title={`Switch to ${nextViewLabel}`}
                aria-label={`Switch to ${nextViewLabel}`}
              >
                <QuotationViewToggleIcon type={viewToggleIconType} />
              </button>

              <button className="btn refresh-btn" type="button" onClick={RefreshList} title="Refresh">
                <i className="fas fa-redo"></i>
              </button>

              <QuotationCreateMenu
                canAdd={menuRights?.canAdd === true}
                navigateToJobInHand={navigateToJobInHand}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(QuotationToolbar);
